import { Component, OnInit } from '@angular/core';
import { combineLatest, filter, map, Observable, switchMap } from 'rxjs';
import { finalize, takeUntil } from 'rxjs';
import { SHA256 } from 'crypto-js';
import { BaseComponent } from '../../../base.component';
import { CriterionsService } from '../../../services/criterions.service';

@Component({
  selector: 'app-masar-question-preview',
  templateUrl: './masar-question-preview.component.html',
  styleUrls: ['./masar-question-preview.component.scss']
})
export class MasarQuestionPreviewComponent extends BaseComponent implements OnInit {
  process$ = this.criterionsService.process$;
  question$ = this.criterionsService.questionResult$;
  answers$: Observable<Array<{ value: string, tooltipAr: string, tooltipEn: string, hasTooltip: boolean }>>;
  attachmentFormKey = this.criterionsService.forms.attachmentsFormKey;
  isLoadingResults = false;

  constructor(private criterionsService: CriterionsService) { super(); }

  ngOnInit(): void {
    this.isLoadingResults = true;
    this.criterionsService.criterion$
      .pipe(
        takeUntil(this.destroy$),
        filter(data => data.criterionType == 'STICK'),
        switchMap(data => this.criterionsService.getQuestion(data.submissionId)
          .pipe(finalize(() => {
            this.isLoadingResults = false;
          })))
      ).subscribe(data => {
        data.evaluationItems?.forEach(item => {
          const jsonString = JSON.stringify(item);
          item.id = SHA256(jsonString).toString();
        });
        this.criterionsService.questionResult$.next(data);
      });
    this.initAnswers();
  }

  private initAnswers() {
    this.answers$ = combineLatest([this.question$, this.criterionsService.process$])
      .pipe(
        map(([question, process]) => {
          if (process.answerMaxScore) {
            const generalToolTip = question.answerTooltip ? question.answerTooltip.find(q => !q.score) : { tooltip: '' };
            return Array.from({ length: process.answerMaxScore }, (_, i) => {
              const answerTooltip = generalToolTip ?? question.answerTooltip.find(q => q.score == i + 1);
              return {
                value: `${i + 1}`,
                tooltipAr: answerTooltip?.tooltipAr,
                tooltipEn: answerTooltip?.tooltipEn,
                hasTooltip: !!answerTooltip?.tooltipAr || !!answerTooltip?.tooltipEn
              }
            });
          }
        }));
  }
}
